import { selectorFamily } from 'recoil';
import ticketsState from '../atoms/tickets';
import Ticket from '../../interfaces/api/Ticket';

const ticketState = selectorFamily<Ticket, Ticket['id']>({
  key: 'ticket',
  get: (id) => ({ get }) => {
    const tickets = get(ticketsState);
    return tickets[id];
  },
  set: (id) => ({ set }, newTicket) => set(ticketsState, (prevState) => ({ ...prevState, [id]: newTicket as Ticket })),
});

export { ticketState };
